import { render } from "./TextEditor.vue?vue&type=template&id=53b0a400"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=53b0a400&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__